import { ethers } from "ethers";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Chart from "../components/Chart";
import PoolChart from "../components/PoolChart";
import { connects } from "../lib/metamask";
import { RootState } from "../store/reducers";
import { updateLoading } from "../store/reducers/loading";
import { updateReport } from "../store/reducers/report";
import { color, flexCenterDir, fullPage, intaglio, levelBtn } from "../styles/theme";
import BugReport from "./BugReport";
import Submissions from "./Submissions";

const Dashboard = () => {
	// const [testStart, setTestStart] = useState(false);
	const [submission, setSubmission] = useState(false);
	const [deposit, setDeposit] = useState(11900);
	// const [report, setReport] = useState(false);

	const dispatch = useDispatch();
	const { report } = useSelector((state: RootState) => state.report);

	const data = [
		{
			id: "Critical",
			label: "Critical",
			value: 1,
			color: color.red,
		},
		{
			id: "High",
			label: "High",
			value: 1,
			color: color.yellow,
		},
		{
			id: "Medium",
			label: "Medium",
			value: 0,
			color: color.blue,
		},
		{
			id: "Low",
			label: "Low",
			value: 1,
			color: color.violet,
		},
	];

	const chartData = [
		{
			DAI: 193,
		},
		{
			DAI: 173,
		},
		{
			DAI: 163,
		},
		{
			DAI: 103,
		},
		{
			DAI: 89,
		},
		{
			DAI: 88,
		},
		{
			DAI: 77,
		},
		{
			DAI: 50,
		},
		{
			DAI: 40,
		},
	];

	const viewDetailHandler = () => {
		// setReport(!report);
		dispatch(updateReport(true));
	};

	const onExitHandler = async () => {
		dispatch(updateLoading(true));
		const exitTx = await connects.signers["BaroqueWorks"].withdraw(1);

		await connects.signers["BaroqueWorks"].provider.once(
			exitTx.hash,
			async (transactionState: any) => {
				if (transactionState.status === 1) {
					try {
						console.log("withdraw 성공");
						setDeposit(0);
						chartData.push({ DAI: 0 });
					} catch (error) {
						console.log(error);
					}
					dispatch(updateLoading(false));
				}
			}
		);
	};

	useEffect(() => {
		dispatch(updateReport(false));
	}, []);

	return (
		<>
			{report ? (
				<BugReport />
			) : (
				<DashboardSection>
					<h2>Dashboard</h2>
					<IntaglioProfile>
						<img src="/dummy/dreamplus.png" alt="profile" />
						<div className="content">
							<h3>DreamPlus</h3>

							<div className="subTitleBox">
								<div className="subTitleBoxItem">
									<h3 className="subTitleBoxItemHeader">Reward</h3>
									<span>$10000 - 60000</span>
								</div>

								<div className="subTitleBoxItem">
									<h3 className="subTitleBoxItemHeader">Bounty Area</h3>
									<div className="labelBox">
										<LevelLabelItem color={"#777777"}>Smart Contract</LevelLabelItem>
									</div>
								</div>
							</div>
							{/* <span>
								<div className="subTitle">Link</div>
								<span
									onClick={() => window.open("https://google.com")}
									style={{ cursor: "pointer", textDecoration: "underline" }}
								>
									https://MakerDAO
								</span>
							</span> */}

							{/* <div className="pentest">
								{testStart ? (
									<span>Deadline: ~22.11.25</span>
								) : (
									<GradientBtn onClick={() => setTestStart(!testStart)}>
										<button>
											Test Start
											<div className="fill"></div>
										</button>
									</GradientBtn>
								)}
							</div> */}
						</div>
						<div className="poolChart">
							<button onClick={() => onExitHandler()}>EXIT</button>
							<span>Deposit: ${deposit}</span>
							<PoolChart data={chartData} />
						</div>
					</IntaglioProfile>
					<div className="lowSection">
						{/* <BountyArea>
							<span className="subTitle">Bounty Area</span>
							<ul>
								<li>SmartContract</li>
							</ul>
						</BountyArea> */}

						<ReportBox>
							<div className="subTitle">
								<span className="subTitleText" onClick={() => setSubmission(!submission)}>
									Reported vulnerabilities
								</span>
								{/* <Link to="/submissions" className="link">
									View submissions
								</Link> */}
							</div>

							<ReportRow>
								<div className="chart">
									<Chart data={data} />
								</div>

								<div className="columnSection">
									<div className="lowSection">
										<LevelItem>
											<LevelLabel color={color.red}>Critical</LevelLabel>
											<span>1</span>
										</LevelItem>
										<LevelItem>
											<LevelLabel color={color.yellow}>High</LevelLabel>
											<span>1</span>
										</LevelItem>
										<LevelItem>
											<LevelLabel color={color.blue}>Medium</LevelLabel>
											<span>0</span>
										</LevelItem>
										<LevelItem>
											<LevelLabel color={color.violet}>Low</LevelLabel>
											<span>1</span>
										</LevelItem>
									</div>

									<div className="lowSection" style={{ justifyContent: "flex-start" }}>
										<ReportItem>
											<span>Reported</span>
											<span>3</span>
										</ReportItem>
										<ReportItem>
											<span>Confirmed</span>
											<span>0</span>
										</ReportItem>
									</div>
								</div>
							</ReportRow>
						</ReportBox>
					</div>

					<Submissions></Submissions>
				</DashboardSection>
			)}
		</>
	);
};

const DashboardSection = styled.section`
	${flexCenterDir}
	${fullPage}

	justify-content: flex-start;

	h2 {
		font-size: 3rem;
		line-height: 3rem;
		width: 70%;
		margin-top: 7.5rem;
		margin-bottom: 2.5rem;
	}

	.lowSection {
		display: flex;
		align-items: flex-start;
		margin-top: 1.25rem;
		width: 70%;
	}
`;

const IntaglioProfile = styled.div`
	${intaglio}

	align-items: flex-start;
	width: 70%;
	padding: 3rem 2.5rem 1.8rem 2.5rem;
	box-sizing: border-box;

	.poolChart {
		height: 10rem;
		width: 19rem;
		position: relative;
		margin-top: 1rem;

		button {
			position: absolute;
			top: -45px;
			right: 0;
			background: #777777;
			border: none;
			border-radius: 0.4rem;
			padding: 0 0.5rem;
			outline: none;
			cursor: pointer;
			font-size: 1.3rem;
			color: ${color.white};
		}

		span {
			position: absolute;
			right: 0;
			text-align: right;
		}
	}

	img {
		width: 12rem;
		margin-right: 5.375rem;
	}

	h3 {
		font-size: 2rem;
		line-height: 0.5rem;
		margin: 0;
		margin-bottom: 3rem;
	}

	.content {
		display: flex;
		flex-direction: column;

		span {
			display: flex;
			font-size: 1rem;
			line-height: 2rem;
			margin-bottom: 1rem;

			&:last-child {
				margin-bottom: 0;
			}
		}

		.pentest {
		}

		.subTitle {
			width: 10rem;
			font-weight: bold;
			font-size: 1.4375rem;
		}

		.subTitleBoxItem {
			margin-bottom: 1.5rem;
		}

		.subTitleBoxItemHeader {
			font-size: 1.5rem;
			font-weight: bold;
			margin-bottom: 1rem;
		}
	}

	.link {
		cursor: pointer;
		border-bottom: 0.0625rem solid ${color.green};
	}

	.subTitleBox {
		display: flex;
		flex-direction: column;
		width: 20rem;

		.subTitle {
			width: 100%;
			font-size: 1rem;
			margin-bottom: 0.5rem;

			.labelBox {
				display: flex;
				justify-content: flex-start;
				width: 100%;
			}
		}
	}
`;

const GradientBtn = styled.div`
	text-align: center;
	position: relative;
	width: 300px;
	cursor: pointer;
	z-index: 1;
	margin-top: 3rem;

	button {
		position: relative;
		height: 50px;
		width: 23.75rem;
		border: 0;
		border-radius: 5px;
		text-transform: uppercase;
		font-size: 1.1em;
		letter-spacing: 0.2em;
		overflow: hidden;
		box-shadow: 0 4px 12px 0 rgba(152, 160, 180, 2);
		z-index: -2;
	}

	.fill {
		position: absolute;
		background-image: linear-gradient(to right, #e040fb, #4bdb17);
		background-size: 150% 150%;
		height: 70px;
		width: 33rem;
		border-radius: 5px;
		margin: -50px 0 0 -140px;
		z-index: -1;
		transition: all 0.4s ease;
	}

	&:hover .fill {
		-webkit-animation: gradient 3s ease infinite;
		-moz-animation: gradient 3s ease infinite;
		animation: gradient 3s ease infinite;
	}

	@-webkit-keyframes gradient {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}

	@-moz-keyframes gradient {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}

	@keyframes gradient {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
`;

const BountyArea = styled.div`
	${intaglio}

	flex-direction:column;
	align-items: center;
	height: 100%;
	margin-right: 1.875rem;
	padding: 1.375rem 0.6rem;
	box-sizing: border-box;
	font-size: 1.4375rem;
	line-height: 2.0625rem;

	ul {
		margin: 0;
		margin-top: 1.875rem;
		padding: 0;
	}

	li {
		font-size: 1rem;
		list-style: none;
		margin: 0;
		margin-bottom: 0.5rem;
		padding: 0;
	}
`;

const ReportBox = styled.div`
	${intaglio}

	flex-direction: column;
	width: 100%;
	padding: 1.375rem 1.5625rem;
	box-sizing: border-box;

	.subTitleBoxItem {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		width: 100%;

		margin-bottom: 0.9375rem;

		.subTitleText {
			font-size: 1.4375rem;
			line-height: 2rem;
		}

		.link {
			color: #885ac6;
		}
	}

	.lowSection {
		display: flex;
		width: 100%;
	}
`;

const ReportRow = styled.div`
	display: flex;
	align-items: flex-start;
	margin-top: 1.375rem;
	width: 100%;

	.chart {
		height: 14rem;
		width: 15rem;
		margin: 0;
	}

	.columnSection {
		display: flex;
		flex-direction: column;
		width: 70%;
	}

	.lowSection {
		display: flex;
		justify-content: space-between;
		margin-right: 1rem;
	}
`;

const LevelItem = styled.div`
	${flexCenterDir}

	align-items: center;
	margin-top: 1.5rem;

	span {
		margin-top: 1rem;
		font-size: 1.3rem;
	}
`;

interface ILevelLabel {
	color: string;
}

const LevelLabel = styled.div<ILevelLabel>`
	${levelBtn}

	background: ${(props) => props.color};
`;

const ReportItem = styled.div`
	${flexCenterDir}

	align-items: flex-start;
	margin-top: 0.5rem;
	margin-right: 3.125rem;

	span {
		font-size: 1.2rem;
		margin-top: 1rem;

		&:first-child {
			font-size: 1.3rem;
			font-weight: bold;
		}
	}
`;

const LevelLabelItem = styled.div<ILevelLabel>`
	${levelBtn}

	background: ${(props) => props.color};
	/* transform: scale(0.7); */
	width: fit-content;
	height: fit-content;
	padding: 0.5rem;
	margin: 0;
	font-size: 0.6rem;
`;

export default Dashboard;
